<template>
    <CardPage :section="15" :page="5">
        <v-card class="mb-1" v-for="(item, index) in answered" :key="index">
            <v-card-title class="pb-0">
                <span class="title">{{ item.text }}</span>
            </v-card-title>
            <v-card-text class="pt-1">
                <div>{{ item.answer }}</div>
                <div>{{ item.other }}</div>
            </v-card-text>
        </v-card>
        <p class="mt-3">
            Did your answer change with the different type of partner? Did you have to think about what WAS the farthest you would go? The point is to think
            about this and consider how far you would go BEFORE you get into a sexual situation and communicate your boundary with your partner. Your partner
            should respect what you feel comfortable doing and not push you to change your mind.
            <br /><br />
            Sometimes once we are all revved up and horny, our brains can get foggy and we engage in things we may not have otherwise done. So your Mother has
            found it helpful to think about her boundaries before getting into sexual situations.
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import { reject, values } from 'lodash';

export default {
    computed: {
        relationships: get('section15/relationships'),
        answered() {
            return reject(values(this.relationships), { answer: '' });
        }
    }
};
</script>
